import { DeviceTile } from './DeviceTile';

export function DeviceTileStatic(props) {
  return <DeviceTile {...props} isNoInteraction={true} />;
}
